import { pipe } from 'ramda'
import { setAction } from '@creditas-lab/analytics-events'
import { dispatchFrontendLoginEvent } from './commons'

const dispatchClickToHome = pipe(
  setAction('user_click_to_home'),
  dispatchFrontendLoginEvent,
)
const dispatchClickToClose = pipe(
  setAction('user_click_to_close'),
  dispatchFrontendLoginEvent,
)

export { dispatchClickToHome, dispatchClickToClose }
